import PropTypes from "prop-types";
import React, { useState } from "react";
import axios from "axios";
import WordList from "./WordList";
import WordTest from "./WordTest";
import { FaRegEdit } from "react-icons/fa";
import { CgNotes } from "react-icons/cg";

const WordListContainer = ({
  initialWordList,
  initialUser,
  activeTab = "edit",
}) => {
  const [wordList, setWordList] = useState(initialWordList);
  const [user, setUser] = useState(initialUser);
  const [currentTab, setCurrentTab] = useState(activeTab);

  const fetchLatestWordList = async () => {
    try {
      const response = await axios.get(`/api/v1/word_lists/${wordList.id}`);
      setWordList(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching word list:", error);
      return null;
    }
  };

  const switchTab = (tabName) => {
    if (tabName === "test") {
      fetchLatestWordList();
    }
    setCurrentTab(tabName);
  };

  const handleWordAdded = async (updatedWordList, updatedUser) => {
    setWordList(updatedWordList);
    if (updatedUser) {
      setUser(updatedUser);
    }
  };

  const handleWordDeleted = async (wordId) => {
    setWordList((prevWordList) => ({
      ...prevWordList,
      words: prevWordList.words.filter((word) => word.id !== wordId),
    }));

    await fetchLatestWordList();
  };

  return (
    <div>
      <div className="mb-6">
        <div className="border-b border-gray-200">
          {wordList && (
            <nav className="-mb-px flex" aria-label="Tabs">
              <button
                className={`tab-button w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${currentTab === "edit" ? "tab-active" : ""}`}
                onClick={() => switchTab("edit")}
              >
                <div className="flex items-center justify-center">
                  <FaRegEdit className="mr-2" />
                  Edit Word List
                </div>
              </button>
              <button
                className={`tab-button w-1/2 py-4 px-1 text-center border-b-2 font-medium text-sm ${currentTab === "test" ? "tab-active" : ""}`}
                onClick={() => switchTab("test")}
              >
                <div className="flex items-center justify-center">
                  <CgNotes className="mr-2" />
                  Take Test
                </div>
              </button>
            </nav>
          )}
        </div>
      </div>

      <div className={currentTab === "edit" ? "" : "hidden"}>
        <WordList
          wordList={wordList}
          initialUser={user}
          onWordAdded={handleWordAdded}
          onWordDeleted={handleWordDeleted}
        />
      </div>
      <div className={currentTab === "test" ? "" : "hidden"}>
        <WordTest wordList={wordList} />
      </div>
    </div>
  );
};

WordListContainer.propTypes = {
  initialWordList: PropTypes.shape({
    id: PropTypes.number.isRequired,
    languageName: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    words: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        word_text: PropTypes.string.isRequired,
      }),
    ),
  }),
  initialUser: PropTypes.shape({
    wordsRemaining: PropTypes.number.isRequired,
    freemium: PropTypes.bool.isRequired,
  }),
  activeTab: PropTypes.string,
};

export default WordListContainer;
